module.exports = __webpack_public_path__ + "img/iAMP_Hydro_horizontal_transparent.5d773ce9.png";